import { Banknote } from "lucide-react";
import { EmptyState } from "@/components/common";
import { FolhaPagamento } from "@/folha";
import { useAuth } from "@/context/AuthContext";
import { canSee } from "@/lib/api";

export default function Folha() {
  const { session } = useAuth();
  if (!canSee(session.user, "folha")) {
    return <EmptyState icon={Banknote} title="Sem acesso à Folha de pagamento" text="Disponível para Dono, Administrador e Gerente nos planos com o módulo Folha de pagamento." />;
  }
  return <div className="overflow-hidden rounded-xl border" data-testid="folha-module"><FolhaPagamento /></div>;
}
